import React from 'react';

import ScoringStandings from './scoring-standings';
import TiebreakNote from './tiebreak-note';
import { groupFormatLabel, groupKey, usesPointSystem, type ScoringGroup } from './scoring-types';

interface Props {
  groups: ScoringGroup[];
  title: string;
  doubles?: boolean;
  skipKey?: string | null;
  big?: boolean;
  onOpenGroup?: (group: ScoringGroup) => void;
}

export const ScoringRoundStandings: React.FC<Props> = ({
  groups,
  title,
  doubles = false,
  skipKey = null,
  big = false,
  onOpenGroup,
}) => {
  const scored = groups.filter(
    (group) => group.standings.length > 0 && groupKey(group) !== skipKey,
  );

  if (scored.length === 0) {
    return null;
  }

  return (
    <section className="scoring-round-standings" data-testid="scoring-round-standings">
      <h2 className="scoring-round-standings__title">{title}</h2>
      {!big && (
        <p className="scoring-hint">
          Na żywo z wpisanych wyników — „Klas." to punkty do klasyfikacji za miejsce w grupie
          (1. w pierwszej grupie = 300, każde kolejne −10).
        </p>
      )}

      {scored.map((group) => (
        <div className="scoring-round-standings__group" key={groupKey(group)}>
          {group.name === null && (
            <div className="tiebreak-note-row">
              <TiebreakNote
                hint={group.tiebreak?.hint}
                steps={group.tiebreak?.steps}
                formatLabel={groupFormatLabel(group)}
                testId={`scoring-standings-${groupKey(group)}-note`}
              />
            </div>
          )}
          {group.name !== null && (
            <div className="scoring-round-standings__group-head">
              <h3 className="scoring-round-standings__group-name">Grupa {group.name}</h3>
              <span className="scoring-round-standings__aside">
                <TiebreakNote
                  hint={group.tiebreak?.hint}
                  steps={group.tiebreak?.steps}
                  formatLabel={groupFormatLabel(group)}
                  testId={`scoring-standings-${groupKey(group)}-note`}
                />
              {onOpenGroup && (
                <button
                  type="button"
                  className="scoring-round-standings__open"
                  data-testid={`scoring-standings-open-${groupKey(group)}`}
                  onClick={() => onOpenGroup(group)}
                >
                  Otwórz grupę →
                </button>
              )}
              </span>
            </div>
          )}
          <ScoringStandings
            rows={group.standings}
            showPoints={usesPointSystem(group)}
            doubles={doubles}
            tiebreakHint={group.tiebreak?.hint}
            restingRunPoints={group.restingRunPoints ?? null}
            testId={`scoring-standings-${groupKey(group)}`}
            compact={big}
            onPickPlayer={big && onOpenGroup ? () => onOpenGroup(group) : undefined}
          />
        </div>
      ))}
    </section>
  );
};

export default ScoringRoundStandings;
